import React, { useState} from 'react';

const FeatureFilterContainerViewing = ({ showPonLayer, handlePonLayerCheckboxChange, showKtvLayer, handleKtvLayerCheckboxChange,
  showEtherLayer, handleEtherLayerCheckboxChange }) => {       

    const [isVisibleDiv, setIsVisibleDiv] = useState(false);

    function toggleVisibilityDiv() {
      setIsVisibleDiv(!isVisibleDiv);
    }

  return (
    <React.Fragment>
      
       <button onClick={toggleVisibilityDiv} className={isVisibleDiv ? 'buttonIsHideDrawer' : 'buttonIsHideDrawer2'}>
         {isVisibleDiv ? 'Признаки: скрыть' : 'Признаки: показать'}
       </button>
     
      {isVisibleDiv && ( 
        <div className='equipmentDiv' style={{marginTop: "10px",textShadow: '2px 2px 4px #242424'}}>
  
         

            
            <input
              type="checkbox"
              checked={showPonLayer}
              onChange={handlePonLayerCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>PON</label>
            <br/>
        
            <input
              type="checkbox"
              checked={showKtvLayer}
              onChange={handleKtvLayerCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>KTV</label>
            <br/>
            <input
              type="checkbox"
              checked={showEtherLayer}
              onChange={handleEtherLayerCheckboxChange}
              style={{ marginRight: '5px' }}
            />
            <label style={{ marginRight: '10px', color: '#bdbdbd'}}>Ethernet</label>
            <br/>
           
           


          </div>
          )}
      </React.Fragment>
  );
}

export default FeatureFilterContainerViewing;